var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('img',{class:_vm.inputClass,style:(_vm.inputStyle),attrs:{"src":_vm.image_url,"alt":"","onerror":"this.src='/assets/img/default-male.svg'"}})])}
var staticRenderFns = []

export { render, staticRenderFns }